export const STATE_COLOURS = {
  EMPTY: 'bg-white',
  PARTIAL: 'bg-lime-400',
  COMPLETED: 'bg-emerald-400',
  ERROR: 'bg-red-500'
} as const